"use client";
import React, { useEffect } from "react";
import { logClientError } from "../hooks/log-client-error";
import { ErrorArtWork } from "./error-art-work";

type SearchXErrorPageProps = {
  refreshUrl?: string;
  messages: {
    tryANewSearch: string;
    heading: string;
    info: string;
  };
  error: Error & { digest?: string };
};

export const SearchXErrorPage = ({
  error,
  messages,
  refreshUrl,
}: SearchXErrorPageProps) => {
  useEffect(() => {
    if (error) {
      logClientError(error);
    }
  }, [error]);

  return (
    <div className="h-full w-full bg-white p-8">
      <div className="flex h-[80%] flex-col items-center justify-center gap-4 md:gap-6 lg:gap-8">
        <ErrorArtWork />
        <div className="flex flex-col items-center justify-center gap-1 md:gap-2 lg:gap-4">
          <h2>{messages.heading}</h2>
          <div className="flex items-center gap-2 text-p-14 sm:text-p-16">
            <span>{messages.info}</span>
            <a href={refreshUrl} className="text-primary hover:underline">
              {messages.tryANewSearch}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
